import React, { lazy } from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mark D.',
    role: 'Youth Club Coach (California, USA)',
    flag: '🇺🇸',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80',
    text: 'I coach club volleyball and preparation time was my biggest stress. With VolleyReady, I got my social life back. The sessions flow perfectly and my players love the new drill structure.'
  }, {
    name: 'Sarah L.',
    role: 'High School Coach (Melbourne, AUS)',
    flag: '🇦🇺',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80',
    text: 'The Season Planner and the Discipline Protocol saved me! I was able to structure my high school program much more professionally. This 6-in-1 bundle is worth every penny.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8 border-t border-pilates-slate/10" data-id="element-238">
      <div className="max-w-5xl mx-auto" data-id="element-239">
        <div className="text-center mb-12" data-id="element-240">
          <div className="border border-pilates-blue-dark text-pilates-blue-dark font-semibold text-xs px-4 py-1.5 mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-241">
            WHAT YOUR COLLEAGUES ARE SAYING
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-blue-dark leading-tight mb-4 tracking-tight" data-id="element-242">
            Testimonials from coaches{' '}
            <span className="italic text-pilates-rose" data-id="element-243">around the world</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-244">
          {testimonials.map((t, idx) => <div key={idx} className="bg-pilates-soft rounded-lg p-8 shadow-sm border border-pilates-slate/10 flex flex-col relative overflow-hidden" data-id="element-245">
              <div className="absolute -top-4 -left-2 text-pilates-lavender opacity-30 font-display text-9xl leading-none select-none" data-id="element-246">
                "
              </div>
              <div className="flex text-pilates-lavender mb-6 relative z-10" data-id="element-247">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-248" />)}
              </div>
              <p className="text-pilates-blue-dark font-medium leading-relaxed mb-8 italic flex-1 text-base relative z-10" data-id="element-249">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4 pt-5 border-t border-pilates-slate/20 relative z-10" data-id="element-250">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" loading="lazy" decoding="async" width="48" height="48" data-id="element-251" />
                <div data-id="element-252">
                  <p className="font-display font-bold text-pilates-blue-dark text-base" data-id="element-253">
                    {t.name}
                  </p>
                  <p className="text-pilates-slate text-xs flex items-center gap-1" data-id="element-254">
                    {t.role} <span data-id="element-255">{t.flag}</span>
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}